import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SalesContractTemplateMailMergeHdrContainerModel } from "../../../../../../models/aggregates/erp/sales-contract";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({ providedIn: 'root' })
export class SalesContractTemplateMailMergeHdrService extends BaseApiTemplateService<SalesContractTemplateMailMergeHdrContainerModel> {

    static readonly SALES_CONTRACT_TEMPLATE_MAIL_MERGE_HDR_SUBPATH = 'sales-contract-template-mail-merge-hdrs/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + SalesContractTemplateMailMergeHdrService.SALES_CONTRACT_TEMPLATE_MAIL_MERGE_HDR_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + SalesContractTemplateMailMergeHdrService.SALES_CONTRACT_TEMPLATE_MAIL_MERGE_HDR_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}